/**
 * Application Configuration
 */

export const APP_CONFIG = {
  name: import.meta.env.VITE_APP_NAME || 'RSUI Deductible Payment Portal',
  version: import.meta.env.VITE_APP_VERSION || '1.0.0',
  sessionTimeout: Number(import.meta.env.VITE_SESSION_TIMEOUT) || 1800000, // 30 minutes
  enableLogging: import.meta.env.VITE_ENABLE_LOGGING === 'true',
  enableDebug: import.meta.env.VITE_ENABLE_DEBUG === 'true',
} as const;

export const VALIDATION_RULES = {
  policyNumber: {
    maxLength: 13,
    pattern: /^[A-Z0-9-]+$/i,
  },
  pin: {
    deductibleLength: 8,
    auditPremiumLength: 10,
    pattern: /^[A-Z0-9]+$/i, // Alphanumeric (letters and numbers)
  },
  amount: {
    min: 0.01,
    max: 999999.99,
  },
} as const;

export const SESSION_KEYS = {
  AUTH_TOKEN: 'rsui_auth_token',
  POLICY_NUMBER: 'rsui_policy_number',
  PAYMENT_TYPE: 'rsui_payment_type',
  BALANCE_DATA: 'rsui_balance_data',
  PAYMENT_AMOUNT: 'rsui_payment_amount',
} as const;
